import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, Flame, User, LayoutDashboard, ShieldCheck } from "lucide-react";
import ThemeToggle from "@/components/ThemeToggle";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";

const NAV = [
  { label: "Mandirs", to: "/mandirs" },
  { label: "Divine Bless", to: "/divine-bless" },
  { label: "Vedic Services", to: "/vedic-services" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const { user, login } = useAuth();
  const { pathname } = useLocation();

  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-background/80 border-b border-border/70" data-testid="main-navbar">
      <div className="px-4 sm:px-6 lg:px-12 max-w-7xl mx-auto flex items-center justify-between h-16 lg:h-20">
        <Link to="/" className="flex items-center gap-2.5 group" data-testid="brand-logo">
          <span className="h-10 w-10 grid place-items-center rounded-full bg-gradient-to-br from-accent to-primary text-white diya-glow">
            <Flame className="h-5 w-5 animate-flicker" />
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-serif text-lg lg:text-xl font-bold tracking-wide">Pavitra Mantra</span>
            <span className="font-devanagari text-[10px] text-muted-foreground tracking-wide">पवित्र मंत्र</span>
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-1">
          {NAV.map((n) => (
            <Link
              key={n.to}
              to={n.to}
              data-testid={`nav-${n.label.toLowerCase().replace(/\s/g, "-")}`}
              className={`px-3.5 py-2 text-sm font-medium rounded-full transition-colors ${
                pathname === n.to ? "text-primary bg-primary/10" : "text-foreground/80 hover:text-primary hover:bg-primary/5"
              }`}
            >
              {n.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-2.5">
          <ThemeToggle />
          {user ? (
            <Link to="/account" data-testid="account-link" className="flex items-center gap-2 pl-1 pr-3 py-1 rounded-full border border-border hover:border-accent transition-colors">
              {user.picture ? (
                <img src={user.picture} alt="" className="h-7 w-7 rounded-full object-cover" />
              ) : (
                <span className="h-7 w-7 grid place-items-center rounded-full bg-secondary"><User className="h-4 w-4" /></span>
              )}
              <span className="hidden sm:block text-sm font-medium max-w-[90px] truncate">{user.name?.split(" ")[0]}</span>
            </Link>
          ) : (
            <Button onClick={login} data-testid="login-button" className="rounded-full bg-primary hover:bg-primary/90 text-primary-foreground text-sm h-9">
              Sign in
            </Button>
          )}
          <button className="lg:hidden h-9 w-9 grid place-items-center" onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle">
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-border bg-background px-4 py-3 space-y-1" data-testid="mobile-menu">
          {NAV.map((n) => (
            <Link key={n.to} to={n.to} onClick={() => setOpen(false)}
              className="block px-3 py-2.5 rounded-lg text-sm font-medium hover:bg-primary/5">
              {n.label}
            </Link>
          ))}
          {user?.roles?.includes("admin") && (
            <Link to="/admin" onClick={() => setOpen(false)} className="flex items-center gap-2 px-3 py-2.5 rounded-lg text-sm font-medium hover:bg-primary/5"><ShieldCheck className="h-4 w-4" /> Admin</Link>
          )}
          <Link to="/purohit" onClick={() => setOpen(false)} className="flex items-center gap-2 px-3 py-2.5 rounded-lg text-sm font-medium hover:bg-primary/5"><LayoutDashboard className="h-4 w-4" /> Purohit Portal</Link>
        </div>
      )}
    </header>
  );
}
